import React from 'react'
import PropTypes from 'prop-types'
import {
    Menu,
    MenuList,
    MenuOptionGroup,
    MenuItemOption,
    MenuButton,
    Text,
    Flex,
    Icon
} from '@chakra-ui/react'
import { ChevronDownIcon, Globe, GlobeDark } from '../icons'
import {FormattedMessage} from 'react-intl'

const CountrySelectorDropdown = ({
    countries,
    language,
    countryCode,
    handleLanguageChange,
    variant = 'header'
}) => {
    const getFooterLabel = (locale) => {
        const [language, country] = locale.split('_')
        const localeTag = `${language}-${country}`
        const displayNames = new Intl.DisplayNames([localeTag], { type: 'region' })
        const countryName = displayNames.of(country)

        const currencySymbol = new Intl.NumberFormat(localeTag, {
            style: 'currency',
            currency: countries?.[locale]?.currency || 'GBP'
        }).format(0).replace(/[\d.,]/g, '').trim()

        return `${countryName} - ${language.toUpperCase()} (${currencySymbol})`
    }

    return (
        <Menu placement="bottom-end">
            <MenuButton
                _focusVisible={{
                    boxShadow: 'var(--chakra-shadows-outline)'
                }}>
                <Flex
                    align="center"
                    ml="auto"
                    columnGap={1}
                >
                    {variant === 'footer' ? (
                        <>
                            <Icon as={GlobeDark} boxSize={5} />
                            <Text fontSize="xs"
                                lineHeight={"15px"}
                                fontWeight={"medium"}
                                letterSpacing={"0%"}
                                paddingLeft={1}>
                                {getFooterLabel(language)}
                            </Text>
                            <Text fontSize="xs"
                                lineHeight={"15px"}
                                fontWeight={"medium"}
                                letterSpacing={"0%"}
                                textDecoration={"underline"}
                                paddingLeft={2}>
                                <FormattedMessage
                                    defaultMessage="Change Country"
                                    id="country_selector.change_country"
                                />
                            </Text>
                        </>
                    ) : (
                        <>
                            <Icon as={Globe} boxSize={5} />
                            <Text
                                fontSize="sm"
                                lineHeight={{lg: '0'}}
                                paddingBottom={{lg: '1px'}}
                                sx={{
                                    '@supports (-webkit-appearance: none) and (stroke-color: transparent)': {
                                        marginTop: {lg: '5px'},
                                        paddingBottom: {lg: 0}
                                    }
                                }}>
                                {countryCode}
                            </Text>
                            <Icon as={ChevronDownIcon} boxSize={5} />
                        </>
                    )}
                </Flex>
            </MenuButton>
            <MenuList borderRadius="0" padding="0">
                <MenuOptionGroup defaultValue={language} value={language} onChange={(e) => handleLanguageChange(e)}>
                    {countries &&
                        Object.entries(countries).map(([lang, { label }], index) => {
                            return (
                                <MenuItemOption
                                    key={lang}
                                    value={lang}
                                    color="black"
                                    fontSize="14px"
                                    lineHeight="18px"
                                    padding="16px 40px 16px 16px"
                                    borderTop={index === 0 ? 'none' : '1px solid #ECE9E9'}
                                >
                                    {label}
                                </MenuItemOption>
                            )
                        })
                    }
                </MenuOptionGroup>
            </MenuList>
        </Menu>
    )
}

CountrySelectorDropdown.propTypes = {
    countries: PropTypes.object,
    language: PropTypes.string,
    countryCode: PropTypes.string,
    handleLanguageChange: PropTypes.func
}

export default CountrySelectorDropdown
